import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import api, {standardApiSlice} from 'service/api'

export const requestPasswordReset = createAsyncThunk('login/requestReset', api.post('/password/email'))

export const requestPasswordResetSlice = createSlice(standardApiSlice('requestPasswordReset', requestPasswordReset))

export const { clearErrors } = requestPasswordResetSlice.actions

export default requestPasswordResetSlice.reducer